import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

const DialogLoading: React.FC = () => {
  return (
    <Stack spacing={1}>
      <Skeleton variant="text" width="80%" height={24} />
      <Stack spacing={0.5}>
        <Skeleton variant="text" width="70%" height={18} />
        <Skeleton variant="text" width="70%" height={18} />
        <Skeleton variant="text" width="70%" height={18} />
      </Stack>
    </Stack>
  )
}

export default DialogLoading
